import clsx from "clsx";
import Flex, { GAP_CLASS } from "components/Flex";
import { bool, func, string } from "prop-types";

import classes from "./ChooserCard.module.scss";

const ChooserCard = ({
  ariaLabel,
  illustration: Illustration,
  title,
  subtitle,
  onClick,
  disabled = false,
  recommended = false,
}) => (
  <div className={classes.cardWrapper}>
    <button
      aria-label={ariaLabel}
      aria-disabled={disabled ? "true" : undefined}
      className={clsx(classes.card, {
        [classes.cardDisabled]: disabled,
        [classes.cardRecommended]: recommended,
      })}
      onClick={disabled ? undefined : onClick}
      type="button"
    >
      <Illustration className={classes.illustration} />
      <Flex gap={GAP_CLASS.GAP_100} className={classes.cardText}>
        <strong>{title}</strong>
        <span className={classes.subtitle}>{subtitle}</span>
      </Flex>
    </button>
    {recommended && (
      <span
        className={clsx(classes.recommendedPill, {
          [classes.recommendedPillDisabled]: disabled,
        })}
      >
        Recommended
      </span>
    )}
  </div>
);

ChooserCard.propTypes = {
  ariaLabel: string.isRequired,
  illustration: func.isRequired,
  title: string.isRequired,
  subtitle: string.isRequired,
  onClick: func.isRequired,
  disabled: bool,
  tooltip: string,
  recommended: bool,
};

export default ChooserCard;
